(() => {
  let googleMapsPromise = null;

  const loadGoogleMaps = (apiKey) => {
    if (window.google && window.google.maps) {
      return Promise.resolve();
    }

    if (googleMapsPromise) {
      return googleMapsPromise;
    }

    googleMapsPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');

      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
      script.async = true;
      script.defer = true;

      script.onload = resolve;
      script.onerror = reject;

      document.head.appendChild(script);
    });

    return googleMapsPromise;
  };


  const geocodeAddress = (address) => {
    return new Promise((resolve, reject) => {

      const geocoder = new google.maps.Geocoder();

      geocoder.geocode(
        { address },
        (results, status) => {

          if (status === 'OK' && results[0]) {
            resolve(results[0].geometry.location);
          } else {
            reject(status);
          }

        }
      );

    });
  };


  class MapSection {

    constructor(section) {

      this.section = section;
      this.mapElement = section.querySelector('[data-map]');

      if (!this.mapElement) return;


      this.apiKey = this.mapElement.dataset.apiKey;
      this.address = this.mapElement.dataset.address;


      if (!this.apiKey || !this.address) {
        console.warn('Google Maps: falta API key o dirección');
        return;
      }


      this.init();

    }


    async init() {

      try {

        await loadGoogleMaps(this.apiKey);


        const location = await geocodeAddress(this.address);


        this.createMap(location);


      } catch(error) {

        console.error(
          'Google Maps error:',
          error
        );

        this.showError();

      }

    }



    createMap(location) {


      const map = new google.maps.Map(
        this.mapElement,
        {
          zoom: 14,
          center: location,

          draggable: false,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          disableDefaultUI: true
        }
      );


      new google.maps.Marker({
        map,
        position: location
      });


      window.addEventListener(
        'resize',
        () => {
          google.maps.event.trigger(
            map,
            'resize'
          );

          map.setCenter(location);

        }
      );


    }



    showError(){

      this.mapElement.innerHTML = `
        <div class="map-error">
          No se pudo cargar el mapa.
        </div>
      `;

    }


  }



  document.addEventListener(
    'DOMContentLoaded',
    () => {

      document
        .querySelectorAll(
          '[data-section-type="map"]'
        )
        .forEach(
          section => new MapSection(section)
        );

    }
  );


})();